import { http } from '@/utils/http.js';
import { orgPath } from '@/utils/paths.js';
import { formatDateWithZone } from '@/utils/filters.js';

export const TripsApi = {
  show(id) {
    return http.get(`${orgPath()}/trips/${id}`).then((response) => {
      // convert the segments object into an array
      if (response.data && response.data.trip && response.data.trip.segments) {
        let segments = Object.keys(response.data.trip.segments);
        segments = segments.map((groupDate, index) => {
          if (index === 0) {
            // flag the first segment in the first group
            response.data.trip.segments[groupDate][0].isFirstSegment = true;
            // TODO: temp
            // response.data.trip.segments[groupDate][2].subType = 'CheckIn';
          }

          response.data.trip.segments[groupDate].forEach((segment) => {
            addOvernightDetail(segment);
            segment.traveler = segment.firstName ? `${segment.firstName} ${segment.lastName}` : null;
            segment.uid = createUid(segment);
          });

          return {
            segmentDate: groupDate,
            segments: response.data.trip.segments[groupDate],
          };
        });

        response.data.trip.segments = segments;
      }

      return response.data;
    });
  },

  destroy(id) {
    return http.delete(`${orgPath()}/trips/${id}`).then((response) => response.data.data);
  },

  getTripBySegment(segmentId, segmentType) {
    return http.get(`${orgPath()}/trips/segments/${segmentType}/${segmentId}`).then((response) => response.data.data);
  },
};

/**
 * Some segment types have multiple psuedo-segments. In these cases we
 * Add some detail props for these psuedo-cards
 * @param {Object} segment - the segment data
 * @returns {Undefined}
 */
function addOvernightDetail(segment) {
  const isCruise = segment.type === 'Cruise';
  const isCheckout = segment.subType === 'CheckOut';
  const nightsOrDays = segment.numberOfNights || segment.numberOfDays;

  // if a checkin then add the checkout date for all types
  if (segment.subType === 'CheckIn') {
    segment.checkout = formatDateWithZone(segment.endDateTime, 'MMMM D');

    // if a nightly or checkout that isn't a cruise then add the total number of nights
  } else if ((segment.subType === 'Overnight' || isCheckout) && !isCruise) {
    segment.night = nightsOrDays;

    // if a checkout and a cruise then we add the start port name
  } else if (isCheckout && isCruise) {
    segment.checkin = segment.startName;
  }
}

/**
 * Greate a unique ID for a segment. To be used with the HTMl ID attribute or anywhere
 * you need a unigue segment identifier
 * @param {Object} segment - the segment data
 * @returns {string}
 */
function createUid(segment) {
  // nightly segments like hotels will have the same info so we tack on which night it is to be unique
  const night = segment.subType === 'Overnight' ? segment.night : '';

  // When we're creating a brand new segment we won't have an id;
  const id = segment.id ? segment.id : 'Create';

  return `${segment.type}${id}${segment.subType}${night}`;
}
